import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './web-d-header.css'

const WebDHeader = (props) => {
  return (
    <div className="web-d-header-web-d-header thq-section-padding">
      <img
        alt={props.imageAlt}
        src={props.imageSrc}
        className="web-d-header-image"
      />
      <div className="web-d-header-container"></div>
      <div className="web-d-header-max-width thq-section-max-width">
        <div className="web-d-header-content">
          <h1 className="web-d-header-text">
            {props.text ?? (
              <Fragment>
                <h1 className="web-d-header-text3 thq-heading-1">
                  SEO Services
                </h1>
              </Fragment>
            )}
          </h1>
          <p className="web-d-header-text1">
            {props.text1 ?? (
              <Fragment>
                <p className="web-d-header-text2 thq-body-large">
                  Choose from our wide variety of plans or reach us for a custom
                  plan to carter your business needs
                </p>
              </Fragment>
            )}
          </p>
          <div className="web-d-header-actions"></div>
        </div>
      </div>
    </div>
  )
}

WebDHeader.defaultProps = {
  imageSrc:
    'https://images.unsplash.com/photo-1657812159055-7bae416f386d?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDQ0fHx3ZWJzaXRlJTIwZGVzaWdufGVufDB8fHx8MTcyMjc5NjQyM3ww&ixlib=rb-4.0.3&w=1500',
  text1: undefined,
  text: undefined,
  imageAlt: 'Digital Marketing Services',
}

WebDHeader.propTypes = {
  imageSrc: PropTypes.string,
  text1: PropTypes.element,
  text: PropTypes.element,
  imageAlt: PropTypes.string,
}

export default WebDHeader
